import { Component, OnInit, EventEmitter } from '@angular/core';
import { HttpService, SessionService, MessageService, TableColumns, TableConfiguration, LocalStorageService, MenuBreadCrumb } from 'brainloper-ui';
import { MatDialog } from '@angular/material/dialog';
import { EndpointDictionary } from 'app/utils/endpoints-dictionary';
import { PermissionsDetailComponent } from '../permissions/permissions-detail/permissions-detail.component';
import { Permissions } from 'app/models2/human-resources/permissions';
import { BaseResponse } from 'app/models2/commos/base-response';
import { GenericResponse } from 'app/models2/commos/generic-response';

@Component({
  selector: 'app-permissions',
  templateUrl: './permissions.component.html',
  styleUrls: ['./permissions.component.scss']
})
export class PermissionsComponent implements OnInit {



  public urlGetPermisos: string = `${EndpointDictionary.Permit.PERMIT_TABLE}`;
  private urlDeletePermiso: string = `${EndpointDictionary.Permit.CRUD_PERMIT_DATA}`;

  public recargarTablaPermisos = new EventEmitter<any>()
  public configurationPermisos: TableConfiguration = {
    edit: false,
    add: true,
    delete: false,
    selectable: false,
    addPer: true,
    editPer: false,
    primaryKey: 'id',
    view: true
  }
  public columnasPermisos: TableColumns<Permissions>[] = [
    {
      ID: 'user',
      label: 'Usuario',
      type: 'number',
      style: {
        textAlign: 'center',
        movil: 'no-movil'
      },
    },
    {
      ID: 'userName',
      label: 'Nombre',
      type: 'string',
      style: {
        textAlign: 'center'
      },
    },
    {
      ID: 'date',
      label: 'Fecha',
      type: 'fecha',
      style: {
        textAlign: 'center'
      },
    },
    {
      ID: 'description',
      label: 'Descripción',
      type: 'string',
      style: {
        textAlign: 'center'
      },
    },
    {
      ID: 'approvedByName',
      label: 'Aprobado por',
      type: 'string',
      style: {
        textAlign: 'center',
        movil:'no-movil'
      },
    }
  ]

  public menuBreadCrumb:Array<MenuBreadCrumb> = [
    {
      name:"Inicio",
      router:'/inicio',
    },
    {
    name:"Permisos",
    current:true
  }]

  constructor(
    private http: HttpService,
    private session: SessionService,
    private message: MessageService,
    public dialog: MatDialog,
    private storage : LocalStorageService
  ) { }

  ngOnInit(): void {
  }



  agregarPermisos($event) {
    //console.log($event)
    this.session.setData('redireccion', 'nuevo')
    let size = screen.width > 1000 ? 90 : 90

    this.dialog.open(PermissionsDetailComponent, {
      width: `${size}%`,
      height: `${size}%`,
      data: ''

    }).afterClosed().subscribe(res=>{
      this.recargarTablaPermisos.emit()
    })
  }

  editarPermisos($event) {
    //console.log($event)
  }

  async eliminarPermisos($event) {
    //console.log($event)
    // let res =  await this.deleteItem.deleteD($event, this.urlDeletePermiso, "id", "Permiso", "Areas")
    //       this.recargarTablaPermisos.emit()

    let params = {
      id:'aprobado_por',
      value:this.storage.get<number>('userId')
    }

    let cuanti
    if ($event.length == 1) {
      cuanti = 'Desea eliminar permiso'
    } else {
      cuanti = 'Desea eliminar permisos'
    }

    this.message.Warning(cuanti, ``, true).then(
      (res: boolean) => {

        if (res == true) {

          $event.forEach(data => {

            this.http.deleteData(`${this.urlDeletePermiso}/${data.id}?aprobado_por=${params.value}`).subscribe(
              (res: BaseResponse<GenericResponse>)  => {
                //console.log(res)
                this.recargarTablaPermisos.emit()

                if (res['code'] == 0) {

                  if ($event.length == 1) {
                    this.message.SuccessToast('Permiso elminado correctamente')
                  } else {
                    this.message.SuccessToast('Permisos elminadaos correctamente')
                  }

                } else {
                  this.message.Error('Error!', `Código: ${res['code']} - Mensaje : ${res['message']}`)
                }
              },
              err => {
                this.message.Error('Error!', err.message)
              }
            )


          });

        } else {
          this.recargarTablaPermisos.emit()
        }
      }
    )
  }

  seleccionadosPermisos($event) {
    //console.log($event)
  }

  viewPermissions($event:Permissions[]) {
    //console.log($event)
    this.session.setData('redireccion', 'visualizar')
    let size = screen.width > 1000 ? 80 : 90

    this.dialog.open(PermissionsDetailComponent, {
      width: `${size}%`,
      height: `${size}%`,
      data: $event[0]

    })
  }


}
